import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { strings } from "../../../../common/i18n";
import actions from "../../../../Store/actions";

/**
 *  Hook for user table data and operations
 */

export default () => {
    const { auditsCreate } = useSelector((state) => state);
    const { data, branchAssetsCount } = auditsCreate;
    const [rows, setRows] = useState([]);
    const dispatch = useDispatch();
    const columns = [
        {
            accessorKey: "branchName",
            header: strings("branch")
        },
        {
            accessorKey: "branchRef",
            header: strings("branchRef")
        },
        {
            accessorKey: "assetsCount",
            header: strings("assetsCount"),
            sortingFn: "alphanumeric"
        }
    ];

    useEffect(() => {
        const uniqueBranches = {};
        const assetCountBranch = {};
        const next = data.reduce((accum, item, index) => {
            if (!uniqueBranches[item.branch]) {
                accum.push({
                    id: index,
                    branch: item.branch,
                    branchName: item.branchName.join(""),
                    branchRef:
                        item.branchRef.length > 0 ? item.branchRef[0] : "",
                    location: item.location,
                    assetsCount: branchAssetsCount[item.branch]
                        ? branchAssetsCount[item.branch]
                        : item.assetsCount
                });
                assetCountBranch[item.branch] = item.assetsCount;
                uniqueBranches[item.branch] = item.branch;
            }
            return accum;
        }, []);
        setRows(next);

        if (Object.keys(branchAssetsCount).length === 0) {
            dispatch(
                actions.auditsCreate.create.itemSet({
                    branchAssetsCount: assetCountBranch
                })
            );
        }
    }, [data]);

    return {
        rows,
        columns
    };
};
